<template>
  <!-- 功能列 -->
  <div :class="{ showing: show }" class="action-bar">
    <img src="@/assets/img/select_count.png" alt="" />

    <div class="action-bar-inner">
      已選擇 {{ selectedCardList.length }} 位

      <!-- 需求單 -->
      <template v-if="cardType === 'demandCard'">
        <slot name="button" :props="cardStatus"></slot>
      </template>

      <!--人員 -->
      <slot name="button"></slot>

      <!-- 需求單 -->
      <template v-if="cardType === 'demandCard'">
        <a
          v-if="cardStatus !== null"
          class="select-all-btn"
          href="javascript:void(0)"
          @click.prevent="selectAllCards"
        >
          全選
        </a>
      </template>

      <!--人員 -->
      <template v-else>
        <a
          class="select-all-btn"
          href="javascript:void(0)"
          @click.prevent="selectAllCards"
        >
          全選
        </a>
      </template>

      <a
        class="clear-all-btn"
        href="javascript:void(0)"
        @click.prevent="clearSelectCard"
      >
        清除
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["show", "cardType", "cardStatus", "selectedCardList"],

  name: "ActionBar",
  data() {
    return {};
  },

  filters: {
    moment: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },

  methods: {
    selectAllCards() {
      this.$emit("selectAllCards");
    },

    clearSelectCard() {
      this.$emit("clearSelectCard");
    },
  },
};
</script>

<style lang="scss" scoped>
.action-bar {
  position: fixed;
  bottom: 18px;
  right: 30px;

  padding: 15px 10px;
  text-align: center;
  transform: translateY(100%);
  transition: all 0.3s;
  &.showing {
    z-index: 10000;
    transform: translateY(0);
    img {
      transform: rotate(0deg);
    }
  }

  i {
    transform: scale(0.8);
    position: relative;
    top: -2px;
  }

  img {
    vertical-align: bottom;
    margin-right: -80px;
    width: 150px;
    position: relative;
    z-index: 12;
    transform: rotate(-93deg);
    transform-origin: right bottom;
    transition: all 0.5s cubic-bezier(0.37, 0.71, 1, 1.23);
  }
  .action-bar-inner {
    display: inline-block;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    padding: 20px;
    padding-left: 50px;
    border-radius: 42px;
    border: 3px solid #ffc727;

    .action-btn {
      background-color: #5380f7;
      display: inline-block;
      padding: 3px;
      border: none;
      border-radius: 50%;
      box-shadow: 3px 0px 5px rgba(0, 0, 0, 0.3);
      position: relative;
      transition: all 0.3s;
      margin-right: 5px;

      span {
        position: absolute;
        white-space: nowrap;
        background-color: #000;
        color: #fff;
        left: 50%;
        bottom: -30px;
        transform: translateX(-50%);
        padding: 3px 10px;
        border-radius: 10px;
        pointer-events: none;
        opacity: 0;
        font-size: 0.8em;
        transition: all 0.3s;

        &::before {
          content: "";
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent #000 transparent;
          position: absolute;
          left: 50%;
          top: -5px;
          transform: translateX(-50%);
        }
      }

      &:hover {
        transform: scale(1.1);

        span {
          opacity: 1;
        }
      }

      &.ban {
        background-color: #dc5555;
      }
    }

    .select-all-btn,
    .clear-all-btn {
      background-color: #eaeaea;
      text-decoration: none;
      padding: 0px 10px;
      line-height: 33px;
      display: inline-block;
      border-radius: 25px;
      font-size: 0.8em;
      cursor: pointer;
    }

    .clear-all-btn {
      margin-left: 5px;
    }
  }
}
</style>
